const fieldConfig = {
  basic: {
    minGapDays: true,
    advanceEMIs: false,
    addBrokenToFirstEmi:true,
    brokenPeriodInterest:true,
    deductBroken : true,
    tenure:true,
    interestStartDate:true,
    flatRateIsAnnual:false,
    Frequency:true,
    daysConversion:true,
    flatInterestType:false
  },

   flat: {
    minGapDays: true,
    advanceEMIs: true,
    addBrokenToFirstEmi:true,
    brokenPeriodInterest:true,
    deductBroken : true,
    tenure:true,
    interestStartDate:true,
    flatRateIsAnnual:false,
    Frequency:true,
    daysConversion:true,
    flatInterestType:true
  },
  Interest: {
    minGapDays: false,
    advanceEMIs: false,
    addBrokenToFirstEmi:false,
    brokenPeriodInterest:true,
    deductBroken : true,
    tenure:true,
    interestStartDate:true,
    flatRateIsAnnual:false,
    Frequency:true,
    daysConversion:true,
    flatInterestType:false
  },
  Bullet: {
    minGapDays: false,
    advanceEMIs: false,
    addBrokenToFirstEmi:false,
    brokenPeriodInterest:false,
    deductBroken : false,
    tenure:false,
    interestStartDate:false,
    flatRateIsAnnual:false,
    Frequency:true,
    daysConversion:true,
    flatInterestType:false
  },
    Subvention: {
    minGapDays: false,
    advanceEMIs: true,
    addBrokenToFirstEmi:false,
    brokenPeriodInterest:false,
    deductBroken : false,
    tenure:true,
    interestStartDate:false,
    flatRateIsAnnual:true,
    Frequency:false,
    daysConversion:false,
    flatInterestType:false
  },



};   


export default fieldConfig;